// Automatically generated with Reach 0.1.8 (dab71275)
/* eslint-disable */
export const _version = '0.1.8';
export const _versionHash = '0.1.8 (dab71275)';
export const _backendVersion = 7;

export function getExports(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getEvents(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getViews(s, viewlib) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Token;
  const ctc2 = stdlib.T_UInt;
  const ctc3 = stdlib.T_Bool;
  
  return {
    infos: {
      Auction: {
        closed: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v581, v582, v583, v584, v585, v589] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
              const [v583, v589, v602, v626, v627, v635, v636] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5))) {
              const [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc3
          },
        currentPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v581, v582, v583, v584, v585, v589] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
              const [v583, v589, v602, v626, v627, v635, v636] = svs;
              return (await ((async () => {
                
                
                return v626;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5))) {
              const [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636] = svs;
              return (await ((async () => {
                
                
                return v626;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc2
          },
        highestBidder: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v581, v582, v583, v584, v585, v589] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
              const [v583, v589, v602, v626, v627, v635, v636] = svs;
              return (await ((async () => {
                
                
                return v627;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5))) {
              const [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636] = svs;
              return (await ((async () => {
                
                
                return v627;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        token: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v581, v582, v583, v584, v585, v589] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
              const [v583, v589, v602, v626, v627, v635, v636] = svs;
              return (await ((async () => {
                
                
                return v602;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5))) {
              const [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636] = svs;
              return (await ((async () => {
                
                
                return v602;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          }
        }
      },
    views: {
      1: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc0],
      3: [ctc0, ctc0, ctc1, ctc2, ctc0, ctc2, ctc2],
      5: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc0, ctc2, ctc0, ctc2, ctc2]
      }
    };
  
  };
export function _getMaps(s) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Tuple([]);
  return {
    mapDataTy: ctc0
    };
  };
export async function Auctioneer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Object({
    creator: ctc0,
    offer: ctc1,
    token: ctc2
    });
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Tuple([]);
  const ctc7 = stdlib.T_Data({
    Bid_acceptOffer0_93: ctc5,
    Bid_close0_93: ctc6,
    Bid_getOffer0_93: ctc5,
    Bid_retractOffer0_93: ctc6
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v582, v583, v584, v585], secs: v587, time: v586, didSend: v36, from: v581 } = txn1;
  ;
  const v589 = v585;
  const v595 = stdlib.protect(ctc3, await interact.getParams(), {
    at: './offer.rsh:50:38:application',
    fs: ['at ./offer.rsh:45:18:application call to [unknown function] (defined at: ./offer.rsh:45:22:function exp)'],
    msg: 'getParams',
    who: 'Auctioneer'
    });
  const v596 = v595.token;
  const v597 = v595.creator;
  const v598 = v595.offer;
  const v599 = stdlib.gt(v598, stdlib.checkedBigNumberify('./offer.rsh:51:20:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v599, {
    at: './offer.rsh:51:11:application',
    fs: ['at ./offer.rsh:45:18:application call to [unknown function] (defined at: ./offer.rsh:45:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  
  const v600 = stdlib.add(v598, stdlib.checkedBigNumberify('./offer.rsh:59:16:decimal', stdlib.UInt_max, 100000));
  
  const txn2 = await (ctc.sendrecv({
    args: [v581, v582, v583, v584, v585, v589, v596, v597, v598],
    evt_cnt: 3,
    funcNum: 1,
    lct: v586,
    onlyIf: true,
    out_tys: [ctc2, ctc0, ctc1],
    pay: [v600, []],
    sim_p: (async (txn2) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v602, v603, v604], secs: v606, time: v605, didSend: v60, from: v601 } = txn2;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v602
        });
      const v607 = stdlib.add(v604, stdlib.checkedBigNumberify('./offer.rsh:59:16:decimal', stdlib.UInt_max, 100000));
      sim_r.txns.push({
        amt: v607,
        kind: 'to',
        tok: undefined
        });
      const v610 = stdlib.gt(v604, stdlib.checkedBigNumberify('./offer.rsh:60:19:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v610, {
        at: './offer.rsh:60:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v614 = stdlib.sub(v607, stdlib.checkedBigNumberify('./offer.rsh:63:12:decimal', stdlib.UInt_max, 20000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./offer.rsh:63:12:decimal', stdlib.UInt_max, 20000),
        kind: 'from',
        to: v582,
        tok: undefined
        });
      const v618 = stdlib.sub(v614, stdlib.checkedBigNumberify('./offer.rsh:64:12:decimal', stdlib.UInt_max, 30000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./offer.rsh:64:12:decimal', stdlib.UInt_max, 30000),
        kind: 'from',
        to: v584,
        tok: undefined
        });
      const v622 = stdlib.sub(v618, stdlib.checkedBigNumberify('./offer.rsh:65:12:decimal', stdlib.UInt_max, 50000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./offer.rsh:65:12:decimal', stdlib.UInt_max, 50000),
        kind: 'from',
        to: v585,
        tok: undefined
        });
      
      
      const v626 = v604;
      const v627 = v601;
      const v628 = true;
      const v629 = v605;
      const v635 = v622;
      const v636 = stdlib.checkedBigNumberify('./offer.rsh:54:6:dot', stdlib.UInt_max, 0);
      
      if (await (async () => {
        
        return v628;})()) {
        sim_r.isHalt = false;
        }
      else {
        sim_r.isHalt = false;
        }
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc0, ctc2, ctc0, ctc1],
    waitIfNotPresent: false
    }));
  const {data: [v602, v603, v604], secs: v606, time: v605, didSend: v60, from: v601 } = txn2;
  ;
  const v607 = stdlib.add(v604, stdlib.checkedBigNumberify('./offer.rsh:59:16:decimal', stdlib.UInt_max, 100000));
  ;
  const v610 = stdlib.gt(v604, stdlib.checkedBigNumberify('./offer.rsh:60:19:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v610, {
    at: './offer.rsh:60:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v614 = stdlib.sub(v607, stdlib.checkedBigNumberify('./offer.rsh:63:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v618 = stdlib.sub(v614, stdlib.checkedBigNumberify('./offer.rsh:64:12:decimal', stdlib.UInt_max, 30000));
  ;
  const v622 = stdlib.sub(v618, stdlib.checkedBigNumberify('./offer.rsh:65:12:decimal', stdlib.UInt_max, 50000));
  ;
  stdlib.protect(ctc4, await interact.signal(), {
    at: './offer.rsh:67:40:application',
    fs: ['at ./offer.rsh:67:18:application call to [unknown function] (defined at: ./offer.rsh:67:22:function exp)'],
    msg: 'signal',
    who: 'Auctioneer'
    });
  
  const v625 = 'Start Auction';
  stdlib.protect(ctc4, await interact.log(v625), {
    at: './offer.rsh:68:40:application',
    fs: ['at ./offer.rsh:68:7:application call to [unknown function] (defined at: ./offer.rsh:68:25:function exp)'],
    msg: 'log',
    who: 'Auctioneer'
    });
  
  let v626 = v604;
  let v627 = v601;
  let v628 = true;
  let v629 = v605;
  let v635 = v622;
  let v636 = stdlib.checkedBigNumberify('./offer.rsh:54:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v628;})()) {
    const txn3 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 4,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v720], secs: v722, time: v721, didSend: v461, from: v719 } = txn3;
    switch (v720[0]) {
      case 'Bid_acceptOffer0_93': {
        const v723 = v720[1];
        ;
        const v767 = stdlib.add(v636, stdlib.checkedBigNumberify('./offer.rsh:105:22:decimal', stdlib.UInt_max, 1));
        ;
        undefined;
        const v769 = v723[stdlib.checkedBigNumberify('./offer.rsh:100:11:spread', stdlib.UInt_max, 0)];
        const v770 = stdlib.gt(v626, stdlib.checkedBigNumberify('./offer.rsh:108:31:decimal', stdlib.UInt_max, 0));
        const v771 = stdlib.ge(v769, stdlib.checkedBigNumberify('./offer.rsh:109:23:decimal', stdlib.UInt_max, 0));
        const v772 = v770 ? v771 : false;
        const v773 = stdlib.le(v769, stdlib.checkedBigNumberify('./offer.rsh:109:35:decimal', stdlib.UInt_max, 99));
        const v774 = v772 ? v773 : false;
        stdlib.assert(v774, {
          at: './offer.rsh:107:18:application',
          fs: ['at ./offer.rsh:106:9:application call to [unknown function] (defined at: ./offer.rsh:106:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v775 = null;
        await txn3.getOutput('Bid_acceptOffer', 'v775', ctc4, v775);
        const v782 = stdlib.div(v635, stdlib.checkedBigNumberify('./offer.rsh:112:36:decimal', stdlib.UInt_max, 100));
        const v783 = stdlib.mul(v769, v782);
        const v785 = stdlib.add(v782, v783);
        const v786 = stdlib.sub(v635, v785);
        const v790 = stdlib.sub(v635, v786);
        ;
        const v794 = stdlib.sub(v790, v783);
        ;
        const v799 = stdlib.sub(v767, v767);
        ;
        const cv626 = v626;
        const cv627 = v627;
        const cv628 = false;
        const cv629 = v721;
        const cv635 = v794;
        const cv636 = v799;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      case 'Bid_close0_93': {
        const v842 = v720[1];
        ;
        ;
        undefined;
        const v921 = stdlib.addressEq(v719, v585);
        const v922 = stdlib.eq(v626, stdlib.checkedBigNumberify('./offer.rsh:153:32:decimal', stdlib.UInt_max, 0));
        const v923 = v921 ? v922 : false;
        stdlib.assert(v923, {
          at: './offer.rsh:151:18:application',
          fs: ['at ./offer.rsh:150:9:application call to [unknown function] (defined at: ./offer.rsh:150:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v924 = null;
        await txn3.getOutput('Bid_close', 'v924', ctc4, v924);
        const cv626 = stdlib.checkedBigNumberify('./offer.rsh:159:13:decimal', stdlib.UInt_max, 0);
        const cv627 = v581;
        const cv628 = false;
        const cv629 = v721;
        const cv635 = v635;
        const cv636 = v636;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      case 'Bid_getOffer0_93': {
        const v961 = v720[1];
        const v981 = v961[stdlib.checkedBigNumberify('./offer.rsh:87:11:spread', stdlib.UInt_max, 0)];
        const v1003 = stdlib.add(v635, v981);
        ;
        ;
        undefined;
        const v1052 = stdlib.gt(v981, v626);
        stdlib.assert(v1052, {
          at: './offer.rsh:91:18:application',
          fs: ['at ./offer.rsh:90:9:application call to [unknown function] (defined at: ./offer.rsh:90:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1056 = stdlib.sub(v1003, v626);
        ;
        const v1057 = null;
        await txn3.getOutput('Bid_getOffer', 'v1057', ctc4, v1057);
        const cv626 = v981;
        const cv627 = v719;
        const cv628 = true;
        const cv629 = v721;
        const cv635 = v1056;
        const cv636 = v636;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      case 'Bid_retractOffer0_93': {
        const v1080 = v720[1];
        ;
        ;
        undefined;
        const v1184 = stdlib.addressEq(v719, v627);
        const v1185 = stdlib.gt(v626, stdlib.checkedBigNumberify('./offer.rsh:134:31:decimal', stdlib.UInt_max, 0));
        const v1186 = v1184 ? v1185 : false;
        stdlib.assert(v1186, {
          at: './offer.rsh:132:18:application',
          fs: ['at ./offer.rsh:131:9:application call to [unknown function] (defined at: ./offer.rsh:131:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1187 = null;
        await txn3.getOutput('Bid_retractOffer', 'v1187', ctc4, v1187);
        const v1197 = stdlib.sub(v635, v635);
        ;
        const cv626 = stdlib.checkedBigNumberify('./offer.rsh:141:13:decimal', stdlib.UInt_max, 0);
        const cv627 = v581;
        const cv628 = true;
        const cv629 = v721;
        const cv635 = v1197;
        const cv636 = v636;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      }
    
    }
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 3,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v1201, time: v1200, didSend: v549, from: v1199 } = txn3;
  ;
  const v1203 = stdlib.addressEq(v589, v1199);
  stdlib.assert(v1203, {
    at: './offer.rsh:167:9:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Auctioneer'
    });
  ;
  ;
  return;
  
  
  
  
  
  
  };
export async function Bid_acceptOffer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_acceptOffer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_acceptOffer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Token;
  const ctc2 = stdlib.T_UInt;
  const ctc3 = stdlib.T_Tuple([ctc2]);
  const ctc4 = stdlib.T_Tuple([]);
  const ctc5 = stdlib.T_Data({
    Bid_acceptOffer0_93: ctc3,
    Bid_close0_93: ctc4,
    Bid_getOffer0_93: ctc3,
    Bid_retractOffer0_93: ctc4
    });
  const ctc6 = stdlib.T_Null;
  
  
  const [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc0, ctc2, ctc0, ctc2, ctc2]);
  const v649 = stdlib.protect(ctc3, await interact.in(), {
    at: './offer.rsh:1:23:application',
    fs: ['at ./offer.rsh:101:9:application call to [unknown function] (defined at: ./offer.rsh:101:9:function exp)', 'at ./offer.rsh:74:19:application call to "runBid_acceptOffer0_93" (defined at: ./offer.rsh:100:11:function exp)', 'at ./offer.rsh:74:19:application call to [unknown function] (defined at: ./offer.rsh:74:19:function exp)'],
    msg: 'in',
    who: 'Bid_acceptOffer'
    });
  const v650 = v649[stdlib.checkedBigNumberify('./offer.rsh:100:11:spread', stdlib.UInt_max, 0)];
  const v651 = stdlib.gt(v626, stdlib.checkedBigNumberify('./offer.rsh:102:29:decimal', stdlib.UInt_max, 0));
  const v652 = stdlib.ge(v650, stdlib.checkedBigNumberify('./offer.rsh:103:21:decimal', stdlib.UInt_max, 0));
  const v653 = v651 ? v652 : false;
  const v654 = stdlib.le(v650, stdlib.checkedBigNumberify('./offer.rsh:103:33:decimal', stdlib.UInt_max, 99));
  const v655 = v653 ? v654 : false;
  stdlib.assert(v655, {
    at: './offer.rsh:101:25:application',
    fs: ['at ./offer.rsh:101:9:application call to [unknown function] (defined at: ./offer.rsh:101:16:function exp)', 'at ./offer.rsh:101:9:application call to [unknown function] (defined at: ./offer.rsh:101:9:function exp)', 'at ./offer.rsh:74:19:application call to "runBid_acceptOffer0_93" (defined at: ./offer.rsh:100:11:function exp)', 'at ./offer.rsh:74:19:application call to [unknown function] (defined at: ./offer.rsh:74:19:function exp)'],
    msg: null,
    who: 'Bid_acceptOffer'
    });
  
  const v677 = ['Bid_acceptOffer0_93', v649];
  
  const txn1 = await (ctc.sendrecv({
    args: [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636, v677],
    evt_cnt: 1,
    funcNum: 4,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc5],
    pay: [stdlib.checkedBigNumberify('./offer.rsh:105:18:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./offer.rsh:105:22:decimal', stdlib.UInt_max, 1), v602]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v720], secs: v722, time: v721, didSend: v461, from: v719 } = txn1;
      
      switch (v720[0]) {
        case 'Bid_acceptOffer0_93': {
          const v723 = v720[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./offer.rsh:105:18:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v767 = stdlib.add(v636, stdlib.checkedBigNumberify('./offer.rsh:105:22:decimal', stdlib.UInt_max, 1));
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./offer.rsh:105:22:decimal', stdlib.UInt_max, 1),
            kind: 'to',
            tok: v602
            });
          undefined;
          const v769 = v723[stdlib.checkedBigNumberify('./offer.rsh:100:11:spread', stdlib.UInt_max, 0)];
          const v771 = stdlib.ge(v769, stdlib.checkedBigNumberify('./offer.rsh:109:23:decimal', stdlib.UInt_max, 0));
          const v772 = v651 ? v771 : false;
          const v773 = stdlib.le(v769, stdlib.checkedBigNumberify('./offer.rsh:109:35:decimal', stdlib.UInt_max, 99));
          const v774 = v772 ? v773 : false;
          stdlib.assert(v774, {
            at: './offer.rsh:107:18:application',
            fs: ['at ./offer.rsh:106:9:application call to [unknown function] (defined at: ./offer.rsh:106:9:function exp)'],
            msg: null,
            who: 'Bid_acceptOffer'
            });
          const v775 = null;
          const v776 = await txn1.getOutput('Bid_acceptOffer', 'v775', ctc6, v775);
          
          const v782 = stdlib.div(v635, stdlib.checkedBigNumberify('./offer.rsh:112:36:decimal', stdlib.UInt_max, 100));
          const v783 = stdlib.mul(v769, v782);
          const v785 = stdlib.add(v782, v783);
          const v786 = stdlib.sub(v635, v785);
          const v790 = stdlib.sub(v635, v786);
          sim_r.txns.push({
            amt: v786,
            kind: 'from',
            to: v719,
            tok: undefined
            });
          const v794 = stdlib.sub(v790, v783);
          sim_r.txns.push({
            amt: v783,
            kind: 'from',
            to: v603,
            tok: undefined
            });
          const v799 = stdlib.sub(v767, v767);
          sim_r.txns.push({
            amt: v767,
            kind: 'from',
            to: v627,
            tok: v602
            });
          const v1854 = v626;
          const v1855 = v627;
          const v1858 = v794;
          const v1859 = v799;
          sim_r.isHalt = false;
          
          break;
          }
        case 'Bid_close0_93': {
          const v842 = v720[1];
          
          break;
          }
        case 'Bid_getOffer0_93': {
          const v961 = v720[1];
          
          break;
          }
        case 'Bid_retractOffer0_93': {
          const v1080 = v720[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc0, ctc2, ctc0, ctc2, ctc2, ctc5],
    waitIfNotPresent: false
    }));
  const {data: [v720], secs: v722, time: v721, didSend: v461, from: v719 } = txn1;
  switch (v720[0]) {
    case 'Bid_acceptOffer0_93': {
      const v723 = v720[1];
      ;
      const v767 = stdlib.add(v636, stdlib.checkedBigNumberify('./offer.rsh:105:22:decimal', stdlib.UInt_max, 1));
      ;
      undefined;
      const v769 = v723[stdlib.checkedBigNumberify('./offer.rsh:100:11:spread', stdlib.UInt_max, 0)];
      const v771 = stdlib.ge(v769, stdlib.checkedBigNumberify('./offer.rsh:109:23:decimal', stdlib.UInt_max, 0));
      const v772 = v651 ? v771 : false;
      const v773 = stdlib.le(v769, stdlib.checkedBigNumberify('./offer.rsh:109:35:decimal', stdlib.UInt_max, 99));
      const v774 = v772 ? v773 : false;
      stdlib.assert(v774, {
        at: './offer.rsh:107:18:application',
        fs: ['at ./offer.rsh:106:9:application call to [unknown function] (defined at: ./offer.rsh:106:9:function exp)'],
        msg: null,
        who: 'Bid_acceptOffer'
        });
      const v775 = null;
      const v776 = await txn1.getOutput('Bid_acceptOffer', 'v775', ctc6, v775);
      if (v461) {
        stdlib.protect(ctc6, await interact.out(v723, v776), {
          at: './offer.rsh:100:12:application',
          fs: ['at ./offer.rsh:100:12:application call to [unknown function] (defined at: ./offer.rsh:100:12:function exp)', 'at ./offer.rsh:111:12:application call to "k" (defined at: ./offer.rsh:106:9:function exp)', 'at ./offer.rsh:106:9:application call to [unknown function] (defined at: ./offer.rsh:106:9:function exp)'],
          msg: 'out',
          who: 'Bid_acceptOffer'
          });
        }
      else {
        }
      
      const v782 = stdlib.div(v635, stdlib.checkedBigNumberify('./offer.rsh:112:36:decimal', stdlib.UInt_max, 100));
      const v783 = stdlib.mul(v769, v782);
      const v785 = stdlib.add(v782, v783);
      const v786 = stdlib.sub(v635, v785);
      const v790 = stdlib.sub(v635, v786);
      ;
      const v794 = stdlib.sub(v790, v783);
      ;
      const v799 = stdlib.sub(v767, v767);
      ;
      const v1854 = v626;
      const v1855 = v627;
      const v1858 = v794;
      const v1859 = v799;
      return;
      
      break;
      }
    case 'Bid_close0_93': {
      const v842 = v720[1];
      return;
      break;
      }
    case 'Bid_getOffer0_93': {
      const v961 = v720[1];
      return;
      break;
      }
    case 'Bid_retractOffer0_93': {
      const v1080 = v720[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_close(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Token;
  const ctc2 = stdlib.T_UInt;
  const ctc3 = stdlib.T_Tuple([]);
  const ctc4 = stdlib.T_Tuple([ctc2]);
  const ctc5 = stdlib.T_Data({
    Bid_acceptOffer0_93: ctc4,
    Bid_close0_93: ctc3,
    Bid_getOffer0_93: ctc4,
    Bid_retractOffer0_93: ctc3
    });
  const ctc6 = stdlib.T_Null;
  
  
  const [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc0, ctc2, ctc0, ctc2, ctc2]);
  const v668 = ctc.selfAddress();
  const v670 = stdlib.protect(ctc3, await interact.in(), {
    at: './offer.rsh:1:23:application',
    fs: ['at ./offer.rsh:145:9:application call to [unknown function] (defined at: ./offer.rsh:145:9:function exp)', 'at ./offer.rsh:74:19:application call to "runBid_close0_93" (defined at: ./offer.rsh:144:13:function exp)', 'at ./offer.rsh:74:19:application call to [unknown function] (defined at: ./offer.rsh:74:19:function exp)'],
    msg: 'in',
    who: 'Bid_close'
    });
  const v671 = stdlib.addressEq(v668, v585);
  const v672 = stdlib.eq(v626, stdlib.checkedBigNumberify('./offer.rsh:147:30:decimal', stdlib.UInt_max, 0));
  const v673 = v671 ? v672 : false;
  stdlib.assert(v673, {
    at: './offer.rsh:145:22:application',
    fs: ['at ./offer.rsh:145:9:application call to [unknown function] (defined at: ./offer.rsh:145:13:function exp)', 'at ./offer.rsh:145:9:application call to [unknown function] (defined at: ./offer.rsh:145:9:function exp)', 'at ./offer.rsh:74:19:application call to "runBid_close0_93" (defined at: ./offer.rsh:144:13:function exp)', 'at ./offer.rsh:74:19:application call to [unknown function] (defined at: ./offer.rsh:74:19:function exp)'],
    msg: null,
    who: 'Bid_close'
    });
  
  const v688 = ['Bid_close0_93', v670];
  
  const txn1 = await (ctc.sendrecv({
    args: [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636, v688],
    evt_cnt: 1,
    funcNum: 4,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc5],
    pay: [stdlib.checkedBigNumberify('./offer.rsh:149:17:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./offer.rsh:149:21:decimal', stdlib.UInt_max, 0), v602]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v720], secs: v722, time: v721, didSend: v461, from: v719 } = txn1;
      
      switch (v720[0]) {
        case 'Bid_acceptOffer0_93': {
          const v723 = v720[1];
          
          break;
          }
        case 'Bid_close0_93': {
          const v842 = v720[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./offer.rsh:149:17:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./offer.rsh:149:21:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v602
            });
          undefined;
          const v921 = stdlib.addressEq(v719, v585);
          const v923 = v921 ? v672 : false;
          stdlib.assert(v923, {
            at: './offer.rsh:151:18:application',
            fs: ['at ./offer.rsh:150:9:application call to [unknown function] (defined at: ./offer.rsh:150:9:function exp)'],
            msg: null,
            who: 'Bid_close'
            });
          const v924 = null;
          const v925 = await txn1.getOutput('Bid_close', 'v924', ctc6, v924);
          
          const v1909 = stdlib.checkedBigNumberify('./offer.rsh:159:13:decimal', stdlib.UInt_max, 0);
          const v1910 = v581;
          const v1913 = v635;
          const v1914 = v636;
          sim_r.isHalt = false;
          
          break;
          }
        case 'Bid_getOffer0_93': {
          const v961 = v720[1];
          
          break;
          }
        case 'Bid_retractOffer0_93': {
          const v1080 = v720[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc0, ctc2, ctc0, ctc2, ctc2, ctc5],
    waitIfNotPresent: false
    }));
  const {data: [v720], secs: v722, time: v721, didSend: v461, from: v719 } = txn1;
  switch (v720[0]) {
    case 'Bid_acceptOffer0_93': {
      const v723 = v720[1];
      return;
      break;
      }
    case 'Bid_close0_93': {
      const v842 = v720[1];
      ;
      ;
      undefined;
      const v921 = stdlib.addressEq(v719, v585);
      const v923 = v921 ? v672 : false;
      stdlib.assert(v923, {
        at: './offer.rsh:151:18:application',
        fs: ['at ./offer.rsh:150:9:application call to [unknown function] (defined at: ./offer.rsh:150:9:function exp)'],
        msg: null,
        who: 'Bid_close'
        });
      const v924 = null;
      const v925 = await txn1.getOutput('Bid_close', 'v924', ctc6, v924);
      if (v461) {
        stdlib.protect(ctc6, await interact.out(v842, v925), {
          at: './offer.rsh:144:14:application',
          fs: ['at ./offer.rsh:144:14:application call to [unknown function] (defined at: ./offer.rsh:144:14:function exp)', 'at ./offer.rsh:155:12:application call to "k" (defined at: ./offer.rsh:150:9:function exp)', 'at ./offer.rsh:150:9:application call to [unknown function] (defined at: ./offer.rsh:150:9:function exp)'],
          msg: 'out',
          who: 'Bid_close'
          });
        }
      else {
        }
      
      const v1909 = stdlib.checkedBigNumberify('./offer.rsh:159:13:decimal', stdlib.UInt_max, 0);
      const v1910 = v581;
      const v1913 = v635;
      const v1914 = v636;
      return;
      
      break;
      }
    case 'Bid_getOffer0_93': {
      const v961 = v720[1];
      return;
      break;
      }
    case 'Bid_retractOffer0_93': {
      const v1080 = v720[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_getOffer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_getOffer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_getOffer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Token;
  const ctc2 = stdlib.T_UInt;
  const ctc3 = stdlib.T_Tuple([ctc2]);
  const ctc4 = stdlib.T_Tuple([]);
  const ctc5 = stdlib.T_Data({
    Bid_acceptOffer0_93: ctc3,
    Bid_close0_93: ctc4,
    Bid_getOffer0_93: ctc3,
    Bid_retractOffer0_93: ctc4
    });
  const ctc6 = stdlib.T_Null;
  
  
  const [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc0, ctc2, ctc0, ctc2, ctc2]);
  const v641 = stdlib.protect(ctc3, await interact.in(), {
    at: './offer.rsh:1:23:application',
    fs: ['at ./offer.rsh:88:9:application call to [unknown function] (defined at: ./offer.rsh:88:9:function exp)', 'at ./offer.rsh:74:19:application call to "runBid_getOffer0_93" (defined at: ./offer.rsh:87:11:function exp)', 'at ./offer.rsh:74:19:application call to [unknown function] (defined at: ./offer.rsh:74:19:function exp)'],
    msg: 'in',
    who: 'Bid_getOffer'
    });
  const v642 = v641[stdlib.checkedBigNumberify('./offer.rsh:87:11:spread', stdlib.UInt_max, 0)];
  const v643 = stdlib.gt(v642, v626);
  stdlib.assert(v643, {
    at: './offer.rsh:88:25:application',
    fs: ['at ./offer.rsh:88:9:application call to [unknown function] (defined at: ./offer.rsh:88:16:function exp)', 'at ./offer.rsh:88:9:application call to [unknown function] (defined at: ./offer.rsh:88:9:function exp)', 'at ./offer.rsh:74:19:application call to "runBid_getOffer0_93" (defined at: ./offer.rsh:87:11:function exp)', 'at ./offer.rsh:74:19:application call to [unknown function] (defined at: ./offer.rsh:74:19:function exp)'],
    msg: null,
    who: 'Bid_getOffer'
    });
  
  const v698 = ['Bid_getOffer0_93', v641];
  
  const txn1 = await (ctc.sendrecv({
    args: [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636, v698],
    evt_cnt: 1,
    funcNum: 4,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc5],
    pay: [v642, [[stdlib.checkedBigNumberify('./offer.rsh:89:26:decimal', stdlib.UInt_max, 0), v602]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v720], secs: v722, time: v721, didSend: v461, from: v719 } = txn1;
      
      switch (v720[0]) {
        case 'Bid_acceptOffer0_93': {
          const v723 = v720[1];
          
          break;
          }
        case 'Bid_close0_93': {
          const v842 = v720[1];
          
          break;
          }
        case 'Bid_getOffer0_93': {
          const v961 = v720[1];
          const v981 = v961[stdlib.checkedBigNumberify('./offer.rsh:87:11:spread', stdlib.UInt_max, 0)];
          const v1003 = stdlib.add(v635, v981);
          sim_r.txns.push({
            amt: v981,
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./offer.rsh:89:26:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v602
            });
          undefined;
          const v1052 = stdlib.gt(v981, v626);
          stdlib.assert(v1052, {
            at: './offer.rsh:91:18:application',
            fs: ['at ./offer.rsh:90:9:application call to [unknown function] (defined at: ./offer.rsh:90:9:function exp)'],
            msg: null,
            who: 'Bid_getOffer'
            });
          const v1056 = stdlib.sub(v1003, v626);
          sim_r.txns.push({
            amt: v626,
            kind: 'from',
            to: v627,
            tok: undefined
            });
          const v1057 = null;
          const v1058 = await txn1.getOutput('Bid_getOffer', 'v1057', ctc6, v1057);
          
          const v1964 = v981;
          const v1965 = v719;
          const v1968 = v1056;
          const v1969 = v636;
          sim_r.isHalt = false;
          
          break;
          }
        case 'Bid_retractOffer0_93': {
          const v1080 = v720[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc0, ctc2, ctc0, ctc2, ctc2, ctc5],
    waitIfNotPresent: false
    }));
  const {data: [v720], secs: v722, time: v721, didSend: v461, from: v719 } = txn1;
  switch (v720[0]) {
    case 'Bid_acceptOffer0_93': {
      const v723 = v720[1];
      return;
      break;
      }
    case 'Bid_close0_93': {
      const v842 = v720[1];
      return;
      break;
      }
    case 'Bid_getOffer0_93': {
      const v961 = v720[1];
      const v981 = v961[stdlib.checkedBigNumberify('./offer.rsh:87:11:spread', stdlib.UInt_max, 0)];
      const v1003 = stdlib.add(v635, v981);
      ;
      ;
      undefined;
      const v1052 = stdlib.gt(v981, v626);
      stdlib.assert(v1052, {
        at: './offer.rsh:91:18:application',
        fs: ['at ./offer.rsh:90:9:application call to [unknown function] (defined at: ./offer.rsh:90:9:function exp)'],
        msg: null,
        who: 'Bid_getOffer'
        });
      const v1056 = stdlib.sub(v1003, v626);
      ;
      const v1057 = null;
      const v1058 = await txn1.getOutput('Bid_getOffer', 'v1057', ctc6, v1057);
      if (v461) {
        stdlib.protect(ctc6, await interact.out(v961, v1058), {
          at: './offer.rsh:87:12:application',
          fs: ['at ./offer.rsh:87:12:application call to [unknown function] (defined at: ./offer.rsh:87:12:function exp)', 'at ./offer.rsh:93:12:application call to "k" (defined at: ./offer.rsh:90:9:function exp)', 'at ./offer.rsh:90:9:application call to [unknown function] (defined at: ./offer.rsh:90:9:function exp)'],
          msg: 'out',
          who: 'Bid_getOffer'
          });
        }
      else {
        }
      
      const v1964 = v981;
      const v1965 = v719;
      const v1968 = v1056;
      const v1969 = v636;
      return;
      
      break;
      }
    case 'Bid_retractOffer0_93': {
      const v1080 = v720[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_retractOffer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_retractOffer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_retractOffer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Token;
  const ctc2 = stdlib.T_UInt;
  const ctc3 = stdlib.T_Tuple([]);
  const ctc4 = stdlib.T_Tuple([ctc2]);
  const ctc5 = stdlib.T_Data({
    Bid_acceptOffer0_93: ctc4,
    Bid_close0_93: ctc3,
    Bid_getOffer0_93: ctc4,
    Bid_retractOffer0_93: ctc3
    });
  const ctc6 = stdlib.T_Null;
  
  
  const [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc0, ctc2, ctc0, ctc2, ctc2]);
  const v659 = ctc.selfAddress();
  const v661 = stdlib.protect(ctc3, await interact.in(), {
    at: './offer.rsh:1:23:application',
    fs: ['at ./offer.rsh:126:9:application call to [unknown function] (defined at: ./offer.rsh:126:9:function exp)', 'at ./offer.rsh:74:19:application call to "runBid_retractOffer0_93" (defined at: ./offer.rsh:125:11:function exp)', 'at ./offer.rsh:74:19:application call to [unknown function] (defined at: ./offer.rsh:74:19:function exp)'],
    msg: 'in',
    who: 'Bid_retractOffer'
    });
  const v662 = stdlib.addressEq(v659, v627);
  const v663 = stdlib.gt(v626, stdlib.checkedBigNumberify('./offer.rsh:128:29:decimal', stdlib.UInt_max, 0));
  const v664 = v662 ? v663 : false;
  stdlib.assert(v664, {
    at: './offer.rsh:126:22:application',
    fs: ['at ./offer.rsh:126:9:application call to [unknown function] (defined at: ./offer.rsh:126:13:function exp)', 'at ./offer.rsh:126:9:application call to [unknown function] (defined at: ./offer.rsh:126:9:function exp)', 'at ./offer.rsh:74:19:application call to "runBid_retractOffer0_93" (defined at: ./offer.rsh:125:11:function exp)', 'at ./offer.rsh:74:19:application call to [unknown function] (defined at: ./offer.rsh:74:19:function exp)'],
    msg: null,
    who: 'Bid_retractOffer'
    });
  
  const v709 = ['Bid_retractOffer0_93', v661];
  
  const txn1 = await (ctc.sendrecv({
    args: [v581, v583, v585, v589, v602, v603, v626, v627, v635, v636, v709],
    evt_cnt: 1,
    funcNum: 4,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc5],
    pay: [stdlib.checkedBigNumberify('./offer.rsh:130:17:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./offer.rsh:130:21:decimal', stdlib.UInt_max, 0), v602]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v720], secs: v722, time: v721, didSend: v461, from: v719 } = txn1;
      
      switch (v720[0]) {
        case 'Bid_acceptOffer0_93': {
          const v723 = v720[1];
          
          break;
          }
        case 'Bid_close0_93': {
          const v842 = v720[1];
          
          break;
          }
        case 'Bid_getOffer0_93': {
          const v961 = v720[1];
          
          break;
          }
        case 'Bid_retractOffer0_93': {
          const v1080 = v720[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./offer.rsh:130:17:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./offer.rsh:130:21:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v602
            });
          undefined;
          const v1184 = stdlib.addressEq(v719, v627);
          const v1186 = v1184 ? v663 : false;
          stdlib.assert(v1186, {
            at: './offer.rsh:132:18:application',
            fs: ['at ./offer.rsh:131:9:application call to [unknown function] (defined at: ./offer.rsh:131:9:function exp)'],
            msg: null,
            who: 'Bid_retractOffer'
            });
          const v1187 = null;
          const v1188 = await txn1.getOutput('Bid_retractOffer', 'v1187', ctc6, v1187);
          
          const v1197 = stdlib.sub(v635, v635);
          sim_r.txns.push({
            amt: v635,
            kind: 'from',
            to: v627,
            tok: undefined
            });
          const v2019 = stdlib.checkedBigNumberify('./offer.rsh:141:13:decimal', stdlib.UInt_max, 0);
          const v2020 = v581;
          const v2023 = v1197;
          const v2024 = v636;
          sim_r.isHalt = false;
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc0, ctc2, ctc0, ctc2, ctc2, ctc5],
    waitIfNotPresent: false
    }));
  const {data: [v720], secs: v722, time: v721, didSend: v461, from: v719 } = txn1;
  switch (v720[0]) {
    case 'Bid_acceptOffer0_93': {
      const v723 = v720[1];
      return;
      break;
      }
    case 'Bid_close0_93': {
      const v842 = v720[1];
      return;
      break;
      }
    case 'Bid_getOffer0_93': {
      const v961 = v720[1];
      return;
      break;
      }
    case 'Bid_retractOffer0_93': {
      const v1080 = v720[1];
      ;
      ;
      undefined;
      const v1184 = stdlib.addressEq(v719, v627);
      const v1186 = v1184 ? v663 : false;
      stdlib.assert(v1186, {
        at: './offer.rsh:132:18:application',
        fs: ['at ./offer.rsh:131:9:application call to [unknown function] (defined at: ./offer.rsh:131:9:function exp)'],
        msg: null,
        who: 'Bid_retractOffer'
        });
      const v1187 = null;
      const v1188 = await txn1.getOutput('Bid_retractOffer', 'v1187', ctc6, v1187);
      if (v461) {
        stdlib.protect(ctc6, await interact.out(v1080, v1188), {
          at: './offer.rsh:125:12:application',
          fs: ['at ./offer.rsh:125:12:application call to [unknown function] (defined at: ./offer.rsh:125:12:function exp)', 'at ./offer.rsh:136:12:application call to "k" (defined at: ./offer.rsh:131:9:function exp)', 'at ./offer.rsh:131:9:application call to [unknown function] (defined at: ./offer.rsh:131:9:function exp)'],
          msg: 'out',
          who: 'Bid_retractOffer'
          });
        }
      else {
        }
      
      const v1197 = stdlib.sub(v635, v635);
      ;
      const v2019 = stdlib.checkedBigNumberify('./offer.rsh:141:13:decimal', stdlib.UInt_max, 0);
      const v2020 = v581;
      const v2023 = v1197;
      const v2024 = v636;
      return;
      
      break;
      }
    }
  
  
  };
export async function Constructor(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Constructor expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Constructor expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Object({
    addr: ctc0,
    addr2: ctc0,
    addr3: ctc0,
    addr4: ctc0
    });
  const ctc2 = stdlib.T_Null;
  const ctc3 = stdlib.T_Token;
  const ctc4 = stdlib.T_UInt;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Tuple([]);
  const ctc7 = stdlib.T_Data({
    Bid_acceptOffer0_93: ctc5,
    Bid_close0_93: ctc6,
    Bid_getOffer0_93: ctc5,
    Bid_retractOffer0_93: ctc6
    });
  
  
  const v576 = stdlib.protect(ctc1, await interact.getParams(), {
    at: './util.rsh:43:38:application',
    fs: ['at ./util.rsh:37:19:application call to [unknown function] (defined at: ./util.rsh:37:23:function exp)', 'at ./offer.rsh:43:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'getParams',
    who: 'Constructor'
    });
  const v577 = v576.addr;
  const v578 = v576.addr2;
  const v579 = v576.addr3;
  const v580 = v576.addr4;
  
  const txn1 = await (ctc.sendrecv({
    args: [v577, v578, v579, v580],
    evt_cnt: 4,
    funcNum: 0,
    lct: stdlib.checkedBigNumberify('./util.rsh:47:6:dot', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    pay: [stdlib.checkedBigNumberify('./util.rsh:47:6:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v582, v583, v584, v585], secs: v587, time: v586, didSend: v36, from: v581 } = txn1;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./util.rsh:47:6:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      const v589 = v585;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0],
    waitIfNotPresent: false
    }));
  const {data: [v582, v583, v584, v585], secs: v587, time: v586, didSend: v36, from: v581 } = txn1;
  ;
  const v589 = v585;
  stdlib.protect(ctc2, await interact.signal(), {
    at: './util.rsh:55:41:application',
    fs: ['at ./util.rsh:55:19:application call to [unknown function] (defined at: ./util.rsh:55:23:function exp)', 'at ./offer.rsh:43:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'signal',
    who: 'Constructor'
    });
  
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 3,
    funcNum: 1,
    out_tys: [ctc3, ctc0, ctc4],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v602, v603, v604], secs: v606, time: v605, didSend: v60, from: v601 } = txn2;
  ;
  const v607 = stdlib.add(v604, stdlib.checkedBigNumberify('./offer.rsh:59:16:decimal', stdlib.UInt_max, 100000));
  ;
  const v610 = stdlib.gt(v604, stdlib.checkedBigNumberify('./offer.rsh:60:19:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v610, {
    at: './offer.rsh:60:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v614 = stdlib.sub(v607, stdlib.checkedBigNumberify('./offer.rsh:63:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v618 = stdlib.sub(v614, stdlib.checkedBigNumberify('./offer.rsh:64:12:decimal', stdlib.UInt_max, 30000));
  ;
  const v622 = stdlib.sub(v618, stdlib.checkedBigNumberify('./offer.rsh:65:12:decimal', stdlib.UInt_max, 50000));
  ;
  let v626 = v604;
  let v627 = v601;
  let v628 = true;
  let v629 = v605;
  let v635 = v622;
  let v636 = stdlib.checkedBigNumberify('./offer.rsh:54:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v628;})()) {
    const txn3 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 4,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v720], secs: v722, time: v721, didSend: v461, from: v719 } = txn3;
    switch (v720[0]) {
      case 'Bid_acceptOffer0_93': {
        const v723 = v720[1];
        ;
        const v767 = stdlib.add(v636, stdlib.checkedBigNumberify('./offer.rsh:105:22:decimal', stdlib.UInt_max, 1));
        ;
        undefined;
        const v769 = v723[stdlib.checkedBigNumberify('./offer.rsh:100:11:spread', stdlib.UInt_max, 0)];
        const v770 = stdlib.gt(v626, stdlib.checkedBigNumberify('./offer.rsh:108:31:decimal', stdlib.UInt_max, 0));
        const v771 = stdlib.ge(v769, stdlib.checkedBigNumberify('./offer.rsh:109:23:decimal', stdlib.UInt_max, 0));
        const v772 = v770 ? v771 : false;
        const v773 = stdlib.le(v769, stdlib.checkedBigNumberify('./offer.rsh:109:35:decimal', stdlib.UInt_max, 99));
        const v774 = v772 ? v773 : false;
        stdlib.assert(v774, {
          at: './offer.rsh:107:18:application',
          fs: ['at ./offer.rsh:106:9:application call to [unknown function] (defined at: ./offer.rsh:106:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v775 = null;
        await txn3.getOutput('Bid_acceptOffer', 'v775', ctc2, v775);
        const v782 = stdlib.div(v635, stdlib.checkedBigNumberify('./offer.rsh:112:36:decimal', stdlib.UInt_max, 100));
        const v783 = stdlib.mul(v769, v782);
        const v785 = stdlib.add(v782, v783);
        const v786 = stdlib.sub(v635, v785);
        const v790 = stdlib.sub(v635, v786);
        ;
        const v794 = stdlib.sub(v790, v783);
        ;
        const v799 = stdlib.sub(v767, v767);
        ;
        const cv626 = v626;
        const cv627 = v627;
        const cv628 = false;
        const cv629 = v721;
        const cv635 = v794;
        const cv636 = v799;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      case 'Bid_close0_93': {
        const v842 = v720[1];
        ;
        ;
        undefined;
        const v921 = stdlib.addressEq(v719, v585);
        const v922 = stdlib.eq(v626, stdlib.checkedBigNumberify('./offer.rsh:153:32:decimal', stdlib.UInt_max, 0));
        const v923 = v921 ? v922 : false;
        stdlib.assert(v923, {
          at: './offer.rsh:151:18:application',
          fs: ['at ./offer.rsh:150:9:application call to [unknown function] (defined at: ./offer.rsh:150:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v924 = null;
        await txn3.getOutput('Bid_close', 'v924', ctc2, v924);
        const cv626 = stdlib.checkedBigNumberify('./offer.rsh:159:13:decimal', stdlib.UInt_max, 0);
        const cv627 = v581;
        const cv628 = false;
        const cv629 = v721;
        const cv635 = v635;
        const cv636 = v636;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      case 'Bid_getOffer0_93': {
        const v961 = v720[1];
        const v981 = v961[stdlib.checkedBigNumberify('./offer.rsh:87:11:spread', stdlib.UInt_max, 0)];
        const v1003 = stdlib.add(v635, v981);
        ;
        ;
        undefined;
        const v1052 = stdlib.gt(v981, v626);
        stdlib.assert(v1052, {
          at: './offer.rsh:91:18:application',
          fs: ['at ./offer.rsh:90:9:application call to [unknown function] (defined at: ./offer.rsh:90:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1056 = stdlib.sub(v1003, v626);
        ;
        const v1057 = null;
        await txn3.getOutput('Bid_getOffer', 'v1057', ctc2, v1057);
        const cv626 = v981;
        const cv627 = v719;
        const cv628 = true;
        const cv629 = v721;
        const cv635 = v1056;
        const cv636 = v636;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      case 'Bid_retractOffer0_93': {
        const v1080 = v720[1];
        ;
        ;
        undefined;
        const v1184 = stdlib.addressEq(v719, v627);
        const v1185 = stdlib.gt(v626, stdlib.checkedBigNumberify('./offer.rsh:134:31:decimal', stdlib.UInt_max, 0));
        const v1186 = v1184 ? v1185 : false;
        stdlib.assert(v1186, {
          at: './offer.rsh:132:18:application',
          fs: ['at ./offer.rsh:131:9:application call to [unknown function] (defined at: ./offer.rsh:131:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1187 = null;
        await txn3.getOutput('Bid_retractOffer', 'v1187', ctc2, v1187);
        const v1197 = stdlib.sub(v635, v635);
        ;
        const cv626 = stdlib.checkedBigNumberify('./offer.rsh:141:13:decimal', stdlib.UInt_max, 0);
        const cv627 = v581;
        const cv628 = true;
        const cv629 = v721;
        const cv635 = v1197;
        const cv636 = v636;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      }
    
    }
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 3,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v1201, time: v1200, didSend: v549, from: v1199 } = txn3;
  ;
  const v1203 = stdlib.addressEq(v589, v1199);
  stdlib.assert(v1203, {
    at: './offer.rsh:167:9:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Constructor'
    });
  ;
  ;
  return;
  
  
  
  
  
  
  };
export async function Relay(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Relay expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Relay expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Token;
  const ctc2 = stdlib.T_UInt;
  const ctc3 = stdlib.T_Tuple([ctc2]);
  const ctc4 = stdlib.T_Tuple([]);
  const ctc5 = stdlib.T_Data({
    Bid_acceptOffer0_93: ctc3,
    Bid_close0_93: ctc4,
    Bid_getOffer0_93: ctc3,
    Bid_retractOffer0_93: ctc4
    });
  const ctc6 = stdlib.T_Null;
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v582, v583, v584, v585], secs: v587, time: v586, didSend: v36, from: v581 } = txn1;
  ;
  const v589 = ctc.iam(v585);
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 3,
    funcNum: 1,
    out_tys: [ctc1, ctc0, ctc2],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v602, v603, v604], secs: v606, time: v605, didSend: v60, from: v601 } = txn2;
  ;
  const v607 = stdlib.add(v604, stdlib.checkedBigNumberify('./offer.rsh:59:16:decimal', stdlib.UInt_max, 100000));
  ;
  const v610 = stdlib.gt(v604, stdlib.checkedBigNumberify('./offer.rsh:60:19:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v610, {
    at: './offer.rsh:60:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v614 = stdlib.sub(v607, stdlib.checkedBigNumberify('./offer.rsh:63:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v618 = stdlib.sub(v614, stdlib.checkedBigNumberify('./offer.rsh:64:12:decimal', stdlib.UInt_max, 30000));
  ;
  const v622 = stdlib.sub(v618, stdlib.checkedBigNumberify('./offer.rsh:65:12:decimal', stdlib.UInt_max, 50000));
  ;
  let v626 = v604;
  let v627 = v601;
  let v628 = true;
  let v629 = v605;
  let v635 = v622;
  let v636 = stdlib.checkedBigNumberify('./offer.rsh:54:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v628;})()) {
    const txn3 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 4,
      out_tys: [ctc5],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v720], secs: v722, time: v721, didSend: v461, from: v719 } = txn3;
    switch (v720[0]) {
      case 'Bid_acceptOffer0_93': {
        const v723 = v720[1];
        ;
        const v767 = stdlib.add(v636, stdlib.checkedBigNumberify('./offer.rsh:105:22:decimal', stdlib.UInt_max, 1));
        ;
        undefined;
        const v769 = v723[stdlib.checkedBigNumberify('./offer.rsh:100:11:spread', stdlib.UInt_max, 0)];
        const v770 = stdlib.gt(v626, stdlib.checkedBigNumberify('./offer.rsh:108:31:decimal', stdlib.UInt_max, 0));
        const v771 = stdlib.ge(v769, stdlib.checkedBigNumberify('./offer.rsh:109:23:decimal', stdlib.UInt_max, 0));
        const v772 = v770 ? v771 : false;
        const v773 = stdlib.le(v769, stdlib.checkedBigNumberify('./offer.rsh:109:35:decimal', stdlib.UInt_max, 99));
        const v774 = v772 ? v773 : false;
        stdlib.assert(v774, {
          at: './offer.rsh:107:18:application',
          fs: ['at ./offer.rsh:106:9:application call to [unknown function] (defined at: ./offer.rsh:106:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v775 = null;
        await txn3.getOutput('Bid_acceptOffer', 'v775', ctc6, v775);
        const v782 = stdlib.div(v635, stdlib.checkedBigNumberify('./offer.rsh:112:36:decimal', stdlib.UInt_max, 100));
        const v783 = stdlib.mul(v769, v782);
        const v785 = stdlib.add(v782, v783);
        const v786 = stdlib.sub(v635, v785);
        const v790 = stdlib.sub(v635, v786);
        ;
        const v794 = stdlib.sub(v790, v783);
        ;
        const v799 = stdlib.sub(v767, v767);
        ;
        const cv626 = v626;
        const cv627 = v627;
        const cv628 = false;
        const cv629 = v721;
        const cv635 = v794;
        const cv636 = v799;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      case 'Bid_close0_93': {
        const v842 = v720[1];
        ;
        ;
        undefined;
        const v921 = stdlib.addressEq(v719, v585);
        const v922 = stdlib.eq(v626, stdlib.checkedBigNumberify('./offer.rsh:153:32:decimal', stdlib.UInt_max, 0));
        const v923 = v921 ? v922 : false;
        stdlib.assert(v923, {
          at: './offer.rsh:151:18:application',
          fs: ['at ./offer.rsh:150:9:application call to [unknown function] (defined at: ./offer.rsh:150:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v924 = null;
        await txn3.getOutput('Bid_close', 'v924', ctc6, v924);
        const cv626 = stdlib.checkedBigNumberify('./offer.rsh:159:13:decimal', stdlib.UInt_max, 0);
        const cv627 = v581;
        const cv628 = false;
        const cv629 = v721;
        const cv635 = v635;
        const cv636 = v636;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      case 'Bid_getOffer0_93': {
        const v961 = v720[1];
        const v981 = v961[stdlib.checkedBigNumberify('./offer.rsh:87:11:spread', stdlib.UInt_max, 0)];
        const v1003 = stdlib.add(v635, v981);
        ;
        ;
        undefined;
        const v1052 = stdlib.gt(v981, v626);
        stdlib.assert(v1052, {
          at: './offer.rsh:91:18:application',
          fs: ['at ./offer.rsh:90:9:application call to [unknown function] (defined at: ./offer.rsh:90:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1056 = stdlib.sub(v1003, v626);
        ;
        const v1057 = null;
        await txn3.getOutput('Bid_getOffer', 'v1057', ctc6, v1057);
        const cv626 = v981;
        const cv627 = v719;
        const cv628 = true;
        const cv629 = v721;
        const cv635 = v1056;
        const cv636 = v636;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      case 'Bid_retractOffer0_93': {
        const v1080 = v720[1];
        ;
        ;
        undefined;
        const v1184 = stdlib.addressEq(v719, v627);
        const v1185 = stdlib.gt(v626, stdlib.checkedBigNumberify('./offer.rsh:134:31:decimal', stdlib.UInt_max, 0));
        const v1186 = v1184 ? v1185 : false;
        stdlib.assert(v1186, {
          at: './offer.rsh:132:18:application',
          fs: ['at ./offer.rsh:131:9:application call to [unknown function] (defined at: ./offer.rsh:131:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1187 = null;
        await txn3.getOutput('Bid_retractOffer', 'v1187', ctc6, v1187);
        const v1197 = stdlib.sub(v635, v635);
        ;
        const cv626 = stdlib.checkedBigNumberify('./offer.rsh:141:13:decimal', stdlib.UInt_max, 0);
        const cv627 = v581;
        const cv628 = true;
        const cv629 = v721;
        const cv635 = v1197;
        const cv636 = v636;
        
        v626 = cv626;
        v627 = cv627;
        v628 = cv628;
        v629 = cv629;
        v635 = cv635;
        v636 = cv636;
        
        continue;
        break;
        }
      }
    
    }
  const txn3 = await (ctc.sendrecv({
    args: [v583, v589, v602, v626, v627, v635, v636],
    evt_cnt: 0,
    funcNum: 3,
    lct: v629,
    onlyIf: true,
    out_tys: [],
    pay: [stdlib.checkedBigNumberify('./offer.rsh:167:9:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn3) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [], secs: v1201, time: v1200, didSend: v549, from: v1199 } = txn3;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./offer.rsh:167:9:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      const v1203 = stdlib.addressEq(v589, v1199);
      stdlib.assert(v1203, {
        at: './offer.rsh:167:9:dot',
        fs: [],
        msg: 'sender correct',
        who: 'Relay'
        });
      sim_r.txns.push({
        amt: v635,
        kind: 'from',
        to: v583,
        tok: undefined
        });
      sim_r.txns.push({
        amt: v636,
        kind: 'from',
        to: v583,
        tok: v602
        });
      sim_r.txns.push({
        kind: 'halt',
        tok: v602
        })
      sim_r.txns.push({
        kind: 'halt',
        tok: undefined
        })
      sim_r.isHalt = true;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc1, ctc2, ctc0, ctc2, ctc2],
    waitIfNotPresent: false
    }));
  const {data: [], secs: v1201, time: v1200, didSend: v549, from: v1199 } = txn3;
  ;
  const v1203 = stdlib.addressEq(v589, v1199);
  stdlib.assert(v1203, {
    at: './offer.rsh:167:9:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Relay'
    });
  ;
  ;
  return;
  
  
  
  
  
  
  };
const _ALGO = {
  appApproval: `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`,
  appClear: `BYEA`,
  extraPages: 0,
  mapDataKeys: 0,
  mapDataSize: 0,
  stateKeys: 2,
  stateSize: 224,
  unsupported: [],
  version: 8
  };
const _ETH = {
  ABI: `[
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v582",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v583",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v584",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v585",
                "type": "address"
              }
            ],
            "internalType": "struct T3",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T4",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "msg",
        "type": "uint256"
      }
    ],
    "name": "ReachError",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v582",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v583",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v584",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v585",
                "type": "address"
              }
            ],
            "internalType": "struct T3",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T4",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e0",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v602",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v603",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v604",
                "type": "uint256"
              }
            ],
            "internalType": "struct T8",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T9",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e1",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T11",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e3",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T14",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T12",
                    "name": "_Bid_acceptOffer0_93",
                    "type": "tuple"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Bid_close0_93",
                    "type": "bool"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T12",
                    "name": "_Bid_getOffer0_93",
                    "type": "tuple"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Bid_retractOffer0_93",
                    "type": "bool"
                  }
                ],
                "internalType": "struct T14",
                "name": "v720",
                "type": "tuple"
              }
            ],
            "internalType": "struct T15",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T16",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e4",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1057",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1187",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v775",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v924",
    "type": "event"
  },
  {
    "stateMutability": "payable",
    "type": "fallback"
  },
  {
    "inputs": [],
    "name": "Auction_closed",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_currentPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_highestBidder",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_token",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_acceptOffer",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Bid_close",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_getOffer",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Bid_retractOffer",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCreationTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentState",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v602",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v603",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v604",
                "type": "uint256"
              }
            ],
            "internalType": "struct T8",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T9",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m1",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T11",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m3",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T14",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T12",
                    "name": "_Bid_acceptOffer0_93",
                    "type": "tuple"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Bid_close0_93",
                    "type": "bool"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T12",
                    "name": "_Bid_getOffer0_93",
                    "type": "tuple"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Bid_retractOffer0_93",
                    "type": "bool"
                  }
                ],
                "internalType": "struct T14",
                "name": "v720",
                "type": "tuple"
              }
            ],
            "internalType": "struct T15",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T16",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m4",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
]`,
  Bytecode: `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`,
  BytecodeLen: 11818,
  Which: `oD`,
  version: 6,
  views: {
    Auction: {
      closed: `Auction_closed`,
      currentPrice: `Auction_currentPrice`,
      highestBidder: `Auction_highestBidder`,
      token: `Auction_token`
      }
    }
  };
export const _Connectors = {
  ALGO: _ALGO,
  ETH: _ETH
  };
export const _Participants = {
  "Auctioneer": Auctioneer,
  "Bid_acceptOffer": Bid_acceptOffer,
  "Bid_close": Bid_close,
  "Bid_getOffer": Bid_getOffer,
  "Bid_retractOffer": Bid_retractOffer,
  "Constructor": Constructor,
  "Relay": Relay
  };
export const _APIs = {
  Bid: {
    acceptOffer: Bid_acceptOffer,
    close: Bid_close,
    getOffer: Bid_getOffer,
    retractOffer: Bid_retractOffer
    }
  };
